import React, { Component } from 'react';
import propTypes from 'prop-types';
import axios from 'axios';

import loader from '../../assets/loader.gif';
import exit from '../../assets/icons/white/exit.png';

export default class FormView extends Component {

  componentDidMount() {
  }
  // Render
  // ----------------------------------------------------
  render() {
    const { formData, viewType } = this.props;

    let theClasses= "FormWrapper";
    if (viewType === 'form') {
      theClasses += ' show'
    }

    let formDate = new Date(formData.date);
    if (formDate.getHours() > 12) {
      formDate = (formDate.getMonth()+1) + '/' + formDate.getDate() + '/' + formDate.getFullYear() + ' at ' + (formDate.getHours() - 12) + ':' + formDate.getMinutes() + 'pm';
    } else {
      if (formDate.getHours() === 12) {
        formDate = (formDate.getMonth()+1) + '/' + formDate.getDate() + '/' + formDate.getFullYear() + ' at ' + formDate.getHours() + ':' + formDate.getMinutes() + 'pm';
      } else {
        formDate = (formDate.getMonth()+1) + '/' + formDate.getDate() + '/' + formDate.getFullYear() + ' at ' + formDate.getHours() + ':' + formDate.getMinutes() + 'am';
      }
    }

    return (
      <div className={theClasses}>
          <div className="navIcon softGrad--primary exit" onClick={this.props.closeFormHandler}>
            <img src={exit} alt="exit" />
          </div>
        <div className="FormModal">
          <div className="inner">

            <div className="header">
              <p>Form created by {formData.exporter}</p>
              <p className="pullRight">{formDate}</p>
            </div>

            <div className="intro formRow">
              <h2>{formData.type}</h2>
              <h4>{formData.company}</h4>
              <p>{formData.address}</p>
            </div>

            {Object.keys(formData).length > 0 ? formData.rows.map((e) => this.formRows(e)) : ''}

          </div>
        </div>
      </div>
    )
  }

  formRows(row) {
    return (
      <div className="formRow">
        {row.map(function(e) {
          if (e.label === 'Notes') {
            let logNotes = e.value.replace(/(?:\r\n|\r|\n)/g, '<br />');
            setTimeout((function() {
              document.getElementById('formNotes').innerHTML = logNotes;
            }).bind(this), 50);

            return (
              <p>{e.label} <br/> <span id="formNotes">{e.value}</span></p>
            )
          } else {
            return (
              <p>{e.label} <span>{e.value}</span></p>
            )
          }
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Globals/Modals/FormView.js